import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageContainer extends StaticContainer {
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/page-container/page-container.component.ts